import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CorporateActionStatusLookup extends ValueObject {
    
    public corporateActionStatusId: number = 0;

    public statusName: string = "";
    
    public corporateActionStageId: number = 0;

    public stageName: string = "";
}